<template>
  <div v-show="isModalVisible">
    <transition name="slide">
      <div id="groupModal15" class="modal-mask" @click="hide">
        <div class="modal-dialog modal-dialog-slideout modal-lg" @click.stop  style="max-width: 100%;">
          <div class="modal-content p-2">
            <div class="modal-header px-4 pt-2 pb-0">
              <div class="" style="width: 100%;">
                <a href="javascript:void(0);" @click="hide" class="text-uppercase text-muted pt-1"  style="color: #6c757d !important;"><img class="back_icon mr-2" src="@/assets/manager/back_button_icon.png"  />Back</a>
                <button type="button" class="close float-right" @click="hide">
                  <span aria-hidden="true">&times;</span>
                </button>
                <div class="clearfix"></div>
              </div>
            </div>
            <div class="modal-body" style="min-height: 700px;">
              <div class="modal_reps_to_review d-none-">



                <div class="row mb-2 mt-3">
                  <div class="col-6 pl-4">
                    <div class="h3 d-inline mr-2 text-uppercase">Branding</div>
                  </div>
                  <div class="col-6 pr-4 text-right">
                  </div>              
                </div>


                <div class="row align-items-center mb-3">
                  <div class="col-12" style="padding-right: 15px;">
                    <div class="px-2">
                      <div class="row">
                        <div class="col-6" >
                          <div class="dropbox" v-if="isInitial">
                            <input 
                              type="file" 
                              name="pdf_file"
                              ref="pdf_file"
                              accept="image/jpeg,image/png"
                              @change="filesChange($event.target.name, $event.target.files)"
                              class="input-file">
                              <p v-if="isInitial" style="padding: 0px 0px 0px 0px; margin-bottom: 0; text-align: center;">
                                <img class="" height="35px" src="@/assets/manager/Mentor Mentee System Icons.png"  />
                              </p>
                              <p style="padding: 10px 0px 0px 0px; margin-bottom: 0; font-weight: bold;">Drag and drop a file to upload</p>
                              <p  style="padding: 0px 0px 15px 0px; font-size: 13px;  margin-bottom: 0;">PNG or JPG upto 2 MB</p>
                              <p style="font-size: 18px; font-weight: bold; padding: 0px 0px 10px 0px; margin-bottom: 0;">OR</p>
                              <p style=" padding: 5px 0px 0px 0px; text-align: center;  margin-bottom: 2px;">
                                <button
                                
                                class="btn ma-blue-btn btn-md input-height-15 text-center" style="border-radius: 10px;"
                                >Browse Files</button>
                              </p>
                            </div>
                            <div class="dropbox1" v-if="isSaving">
                              <p>
                                <div class="row">
                                  <div class="col-10 " style="padding-top: 0px; padding-left: 30px;">
                                    <img class="" height="100" :src="image"  />
                                  </div>
                                  <div class="col-1" style="padding-top: 40px;" >
                                    <button type="button" class="close float-right" @click="removeFile()">
                                      <span aria-hidden="true">&times;</span>
                                    </button>                             
                                  </div>
                                </div>
                              </p>
                          </div>
                          <p v-if="uploadError" class="text-danger">{{uploadError}}</p>
                        </div>
                        <div class="col-6" >
                          <div class="row">
                          <div class="col-12 text-left pt-1">
                            Color: 
                          </div>
                          <div class="col-12 datepicker-custom">
                            <input v-model="colors"
                              name="colors"
                              placeholder="" v-validate="'required'" 
                              class="col-9 input-class input-height-25 text-left"
                              maxlength="10" />
                              <i class="fa fa-plus-circle" @click="togglePicker()" style="cursor: pointer; font-size: 17px; margin-top: 2px;"></i>
                          </div>
                          <div  v-if="verrors.firstByRule('colors', 'required')" class="col-12 validate-warning-msg">Color is required</div>
                          </div>
                          <div class="col-12 override-padding form-group">
                            <Sketch :value="colors" @input="updateFromPicker" v-show="displayPicker" class="vc-left" />
                          </div>










                        </div>
                      </div>
                      <div class="row pt-2">
                        <div class="col p-0">

                          <label
                            for="mentor"
                            class="col-12 bold"> Assign Accounts</label>
                            
                          <div class="ml-3" v-if="accounts.length == 0">No accounts found!</div>

                          <div class="col-12 col-sm-12 tasklist-assign-wrapper" v-for="(option, key, index) in accounts">
                            <div class="custom-control custom-checkbox">
                              <input name="account_assigned" v-validate="'required'" type="checkbox" class="custom-control-input" :value="option.id" :id="form_type + '_mentee_' + option.id" v-model="assign_accounts">
                              <label class="custom-control-label" :for="form_type + '_mentee_' + option.id">{{ option.name }}</label>
                            </div>
                          </div>
                          <div  v-if="verrors.has('account_assigned')" class="col margin-bottom-5 validate-warning-msg">Assign Accounts is required</div>


                        </div>
                      </div>


                      <div class="row pt-3">
                        <div class="col-12 text-center">
                          <button v-if="disable_add == true" disabled="true" class="btn btn-dard-grey btn-md input-height-15 text-center" style="border-radius: 10px;">Save</button>
                          <button v-else  
                          :disabled="disable_add"
                          @click="onSubmit()"
                          class="btn ma-blue-btn btn-md input-height-15 text-center" style="border-radius: 10px;"
                          >Save</button>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer"></div>
          </div>
        </div>
      </div>
    </transition>




  </div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import axios from 'axios';
import EventBus from '../../bus';
import MenteePathwayProgress from '@/components/manager/mentee_pathway_progress.vue';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import moment from 'moment';
import ColourPicker from 'vue-colour-picker';
import { Sketch } from 'vue-color'
import { store } from '../../store/store';
import VeeValidate from 'vee-validate';
Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

const STATUS_INITIAL = 0, STATUS_SAVING = 1, STATUS_SUCCESS = 2, STATUS_FAILED = 3;

const today = new Date();
today.setHours(0, 0, 0, 0);

export default {
  props: ['isModalVisible', 'type'],
  data() {
    return {
      uploadError: '',
      loading: false,
      currentStatus: null,
      uploadedFiles: [],
      menteeId: '',
      certId: '',
      stepId: '',
      objectiveId: '',
      issued_date: '',
      expiration_date: '',
      verification_code: '',
      certificates: [],
      filename: '',
      disable_add: true,
      ref_pdf_file: {},
      menteeFirstName: '',
      menteeShortName: '',
      mentorsAssigned: [],
      pathwayStepsData: [],
      activeStep: '',
      colors: '',
      sub_domain: '',
      displayPicker: false,
      host: '',
      protocol: '',
      fullDomain: '',
      image: '',
      edit_flag: 0,
      assign_accounts: [],
      accounts: [],

    }
  },
  computed: {
          isInitial() {
            return this.currentStatus === STATUS_INITIAL;
          },
          isSaving() {
            return this.currentStatus === STATUS_SAVING;
          },
          isSuccess() {
            return this.currentStatus === STATUS_SUCCESS;
          },
          isFailed() {
            return this.currentStatus === STATUS_FAILED;
          }
    
  },
  methods: {

    showPicker() {
      document.addEventListener('click', this.documentClick);
      this.displayPicker = true;
    },

    hidePicker() {
      document.removeEventListener('click', this.documentClick);
      this.displayPicker = false;
    },
    togglePicker() {
      this.displayPicker ? this.hidePicker() : this.showPicker();
    },
    updateFromPicker(color) {
      this.colors = color.hex;
      this.displayPicker = false;
    },
    updateColor(color) {
      this.colors = color;
    },

    disabledAfterToday(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return date > today
    },
    hide() {
      this.$emit('close');
    },
    removeFile() {
      this.filename == '';
      this.disable_add = true;
      this.ref_pdf_file = {};
      this.currentStatus = STATUS_INITIAL;
      this.image = '';
    },
    dovalidate() {
      var vflag = 1;
      if(this.edit_flag == 0) {
        if(this.filename == '') {
          alert("Please upload Logo");
          vflag = 0;
          return false;
        }
        else if(this.ref_pdf_file.files[0].size > 2000000) {
          alert("Logo size should be of 2 MB only");
          vflag = 0;
          return false;
        }
        else {
          if((this.ref_pdf_file.files[0].type != 'image/jpeg') && (this.ref_pdf_file.files[0].type != 'image/jpg') && (this.ref_pdf_file.files[0].type != 'image/png')) {
            alert("Logo should be of jpeg, jpg, png formats only");
            vflag = 0;
            return false;
            }
        }
      }
      return vflag;
    },
    createBase64Image(fileObject){
      const reader = new FileReader();
      reader.onload = (e) => {
        this.image = e.target.result;
      };
      reader.readAsDataURL(fileObject);
    },

    filesChange(fieldName, fileList) {
      this.edit_flag = 0;
      this.currentStatus = STATUS_SAVING;
      this.createBase64Image(this.$refs.pdf_file.files[0]);
      this.filename = this.$refs.pdf_file.files[0].name;
      this.totalSizeMB = this.$refs.pdf_file.files[0].size / Math.pow(1024,2);
      this.totalSizeMB = parseFloat(this.totalSizeMB).toFixed(2);
      this.ref_pdf_file = this.$refs.pdf_file;
      this.disable_add = false;
    },
    nameRegex: function() {
      return /^[a-z']*$/;
    },

    onSubmit() {
      this.$validator.validateAll().then((result) => {
      if(!result) {
        return;
      }



        
        var vflag = this.dovalidate();
        if(vflag == 1) {
          this.disable_add = true;
          Vue.prototype.$logoName = 'MM-logo.png';
          this.fullDomain = this.protocol + this.sub_domain + this.host;
          const pdfData = new FormData();
          if(this.edit_flag == 0) {
            pdfData.append("pdf_file", this.ref_pdf_file.files[0], this.ref_pdf_file.files[0].name);
          }
          pdfData.append("edit_flag", this.edit_flag);
          pdfData.append("account_id", this.$store.state.user_accountid);
          pdfData.append("assign_accounts", this.assign_accounts);
          pdfData.append("color", this.colors);

          axios.post('/account-branding-upload-logo', pdfData, {
              headers: {
                'Access-Control-Allow-Origin': '*',
                'Accept': 'image/png, image/jpg',
                'Content-Type': 'multipart/form-data'
              },
          })
          .then(resp => {
            this.$logoName = 'MM-logo.png';
            this.hide();
          })
          .catch(error => {
            this.disable_add = false;

          })
        }


      })
      .catch(() => {

      });

    },

    loadInitialData() {
      this.currentStatus = STATUS_INITIAL;
      this.assign_accounts = [];
      this.colors = '';
      axios('/enterprise_admin_get_active_accounts_lists', {
        method: 'GET',
        params: {
          accountId: this.$store.state.user_accountid, 
        }
      })
      .then(resp => {
        this.accounts = resp.data;
      })
      .catch(() => {});

      axios('/desktop/get-account-branding', {
        method: 'GET',
        params: {
          account_id: this.$store.state.user_accountid, 
        }
      })
      .then(resp => {
        if(resp.data.image != '') {
          this.currentStatus = STATUS_SAVING;
          this.edit_flag = 1;
          this.disable_add = false;
        }
        this.image = resp.data.image;
        this.colors = resp.data.color;
        this.sub_domain = resp.data.subdomain;
        this.assign_accounts = resp.data.accounts;
      })
      .catch(() => {});


            
      setTimeout(() => {
        let element = document.getElementById('groupModal15');    
        element.scrollIntoView(true);
      }, 2000); 
    },
  },
  components: {
    MenteePathwayProgress,
    DatePicker,
    ColourPicker,
    Sketch,

  },
  created() {
    if(process.env.NODE_ENV == 'production') {
      this.host = "." + process.env.HOST;
    }
    else {
      this.host = "-" + process.env.HOST;
    }
    this.protocol = window.location.protocol + "//";
  },
  mounted() {

  }
}
</script>

<style scoped>
.back_icon { width: 14px; }
.mentee_title_btn {
  background-color: #b3e6fa;
  padding: 2px 10px;
  border-radius: 8px;
  font-size: 12px;
  color: #2d6074;
  border: 0;
  margin-top: -12px;
}
.progress_step {
  height:10px;
  margin-top: 5px;
}
.panel-title a {
  font-size: 14px;
  color: #002F42 !important;
  font-weight: normal;
  padding-left: 0px;
}


::-webkit-scrollbar {
    width: 0;  /* Remove scrollbar space */
    background: transparent;  /* Optional: just make scrollbar invisible */
}
.modal-mask {
    position: fixed;
    z-index: 1001;
    top: 59px;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .2);
    transition: opacity .3s ease;
    overflow-y: scroll;
}
.modal-mask1 {
    position: fixed;
    z-index: 1001;
    top: 0px;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .2);
    transition: opacity .3s ease;
    overflow-y: scroll;
}
.modal-dialog {
  animation: slide-in 1s forwards;
  -webkit-animation: slide-in 1s forwards;
}

@keyframes slide-in {
  0% {
    -webkit-transform: translateX(100%);
  }
  100% {
    -webkit-transform: translateX(0%);
  }
}

@-webkit-keyframes slide-in {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(0%);
  }
}
.modal-dialog {
  max-width: 90%;
}
@media (min-width: 992px) {
    .modal-lg, .modal-xl { width: 700px; }
}
@media (max-width: 576px){ 
    .modal-dialog.modal-dialog-slideout { width: 80% }
}
.modal-dialog-slideout {
    min-height: 100%; margin: 0 0 0 auto; background: #fff; 
}
.modal-dialog-slideout .modal-content{ border: 0; }
.modal-header { border-bottom: none; }
.modal-footer { border-top: none; }
.modal-goback { font-size: 24px; margin: 5px 10px 0 0; cursor: pointer; }
.modal-title { font-weight: 900; }
.maheading_1 { width: 5%; }
.maheading_2 { width: 75%; }
.maheading_3 { width: 20%; }
@media (min-width: 1200px) {
  .modal-lg {
    width: 690px;
  }
}
@media (min-width: 992px) and (max-width: 1199.98px) {
  .modal-lg {
    width: 690px;
  }
}
@media (max-width: 1199.98px) {
  .progress_item_link {
    font-size: 13px;
    cursor: pointer;
  }
}
.progress_item_link {
  cursor: pointer;
}
.objective-view-icon {
  width: 15px;
  margin-left: 2px !important;
}
.search_tasks_txtbox input {
  height: 30px;
  border-right: 0;
  width: 125px !important;
  font-size: 12px;
  border-radius: 10px;
}
.search_tasks_txtbox input:active,
.search_tasks_txtbox input:focus,
.search_tasks_txtbox input:hover {
  border-color: #ced4da !important;
}
.search_tasks_txtbox .input-group-text {
  background-color: #FFFFFF;
  color: lightgray;
  border-radius: 10px;
  padding-bottom: 0px;
  padding-top: 0px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
/* Upload Form CSS Start */
.dropbox {
  border: 1px dashed grey; /* the dash box */
  border-radius: 10px;
  outline-offset: -10px;
  background: white;
  color: dimgray;
  padding: 10px 10px;
  min-height: 180px; /* minimum height */
  position: relative;
  cursor: pointer;
}
.dropbox1 {
  border: 1px solid grey; /* the dash box */
  border-radius: 10px;
  outline-offset: -10px;
  background: white;
  min-height: 80px;
}
.input-file {
  opacity: 0; /* invisible but it's there! */
  width: 100%;
  height: 200px;
  position: absolute;
  cursor: pointer;
}
.dropbox:hover {
  background: white; /* when mouse over to the drop zone, change color */
}
.dropbox p {
  font-size: 1.2em;
  text-align: center;
  padding: 50px 0;
}
/* Upload Form CSS End */
.input-class  {
  border: 1px solid #002F42; 
  border-radius: 10px;
}
.mx-datepicker {
  width: auto;
}
.mx-datepicker .input-class {
  border-radius: 10px;
  //padding-right: 25px;
  border: 1px solid #002F42; 
}
.progress_pathway {
  height:8px;
  margin-top: 5px;
}
.progress_pathway {
  height:5px;
  margin-top: 5px;
}
.pw_step_title {
  font-size: 12px;
}
.pw_step_title_active {
  font-size: 12px;
}
.pw_step_title_active span {
  color: #FFFFFF;
  padding: 0px 6px;
  border-radius: 4px;
  display: inline-block;
}

</style>
<style>
.mx-datepicker .input-class {
  border-radius: 10px;
  padding-right: 25px;
  border: 1px solid #002F42; 
}
.mx-datepicker-popup {
  position: absolute !important;
  z-index: 99999;
}
.vc-sketch {
    position: absolute !important;
    top: -50px !important;
    left: 50px !important;
}

</style>


// WEBPACK FOOTER //
// src/components/enterpriseadmin/branding_settings.vue